import { styled } from "@mui/material";
import Mui5 from "components/mui5";

export const Paper = styled(Mui5.Paper)({
  height: "100%",
  width: 720,
  margin: "auto",
});
